// Enhanced testimonials data with more diverse client base
export const testimonials = [
  {
    id: 1,
    name: "Ahmad Hassan",
    role: "CTO",
    company: "Regtify",
    location: "Cyprus",
    clientTag: "Cyprus Client",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
    text: "Bakhtawar is an exceptional developer who consistently delivers high-quality solutions. His expertise in full-stack development has been invaluable to our fintech platform. The attention to detail and problem-solving skills are remarkable.",
    rating: 5,
    projectType: "Fintech Platform Development"
  },
  {
    id: 2,
    name: "Sarah Ahmed",
    role: "Lead Data Engineer",
    company: "Xnitia",
    location: "USA",
    clientTag: "USA Client",
    image: "https://images.unsplash.com/photo-1494790108755-2616b332c2e1?w=100&h=100&fit=crop&crop=face",
    text: "Working with Bakhtawar on data engineering projects was fantastic. His knowledge of AWS and PySpark helped us build scalable data pipelines that process terabytes of data efficiently. Highly recommended!",
    rating: 5,
    projectType: "Data Engineering & AWS Solutions"
  },
  {
    id: 3,
    name: "James Mitchell",
    role: "Product Manager",
    company: "TechFlow Solutions",
    location: "UK",
    clientTag: "UK Client",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
    text: "Bakhtawar delivered our e-commerce platform ahead of schedule with exceptional quality. The user interface is intuitive and the backend is robust. Great communication throughout the project.",
    rating: 5,
    projectType: "E-commerce Platform"
  },
  {
    id: 4,
    name: "Maria Rodriguez",
    role: "Startup Founder",
    company: "InnovateLab",
    location: "Spain",
    clientTag: "Spain Client",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
    text: "As a startup, we needed someone who could handle both frontend and backend development efficiently. Bakhtawar exceeded our expectations with his technical expertise and professional approach.",
    rating: 5,
    projectType: "Startup MVP Development"
  },
  {
    id: 5,
    name: "David Chen",
    role: "Senior Software Architect",
    company: "CloudTech Inc",
    location: "Canada",
    clientTag: "Canada Client",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face",
    text: "Bakhtawar's system design skills are impressive. He helped us architect a scalable microservices solution that handles millions of requests daily. His DevOps knowledge was also invaluable.",
    rating: 5,
    projectType: "Microservices Architecture"
  },
  {
    id: 6,
    name: "Emily Watson",
    role: "Digital Marketing Director",
    company: "BrandBoost",
    location: "Australia",
    clientTag: "Australia Client",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face",
    text: "The analytics dashboard Bakhtawar built for us has transformed how we track our marketing campaigns. The real-time visualizations and automated reporting save us hours every week.",
    rating: 5,
    projectType: "Analytics Dashboard"
  }
];

export const getTestimonialsByLocation = () => {
  const locationStats = {};
  testimonials.forEach(testimonial => {
    const location = testimonial.location;
    if (!locationStats[location]) {
      locationStats[location] = {
        count: 0,
        clients: []
      };
    }
    locationStats[location].count++;
    locationStats[location].clients.push(testimonial);
  });
  return locationStats;
};

export const getFeaturedTestimonials = () => {
  return testimonials.filter(testimonial => 
    ['Cyprus Client', 'USA Client', 'UK Client'].includes(testimonial.clientTag)
  );
};